import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { business } from '../data/business';
import { LanguageToggle } from './LanguageToggle';
export function Footer() {
  const {
    t
  } = useLanguage();
  const links = [{
    href: '#services',
    label: t.nav.services
  }, {
    href: '#about',
    label: t.nav.about
  }, {
    href: '#philosophy',
    label: t.nav.philosophy
  }, {
    href: '#faq',
    label: t.nav.faq
  }, {
    href: '#contact',
    label: t.nav.contact
  }];
  const linkClass = 'inline-flex min-h-[40px] items-center text-[15px] text-cream/75 transition-colors duration-200 hover:text-white';
  return <footer className="on-dark bg-ink text-cream" data-id="element-107" data-mp="3qdf393nbcu92">
      <div className="mx-auto max-w-7xl px-6 py-20 md:px-10" data-id="element-108" data-mp="3qbvnde5kkl7t">
        <div className="grid gap-12 md:grid-cols-12" data-id="element-109" data-mp="29ynldknsn5e0">
          <div className="md:col-span-5" data-id="element-110" data-mp="2a19tpmiidoxa">
            <p className="font-display text-[16px] font-semibold tracking-[0.38em] text-white" data-id="element-111" data-mp="2eyt8cnj4c3pr">ALMA YOGA</p>
            <p className="mt-3 font-serif text-[19px] italic text-cream/75" data-id="element-112" data-mp="3l8qvw2zluhqx">{t.footer.tagline}</p>
            <div className="mt-8" data-id="element-113" data-mp="3gb8wb37h9evl">
              <p className="text-[13px] text-cream/50" data-id="element-114" data-mp="3gc0jbpn0e4a9">{t.footer.language}</p>
              <div className="mt-1 text-white" data-id="element-115" data-mp="3v8rl25k5ns31">
                <LanguageToggle data-id="element-116" data-mp="3v5dhitzr9cu0" />
              </div>
            </div>
          </div>

          <nav aria-label="Footer" className="md:col-span-2" data-id="element-117" data-mp="3qaq1ljithqr1">
            <h2 className="text-[13px] font-medium text-cream/50" data-id="element-118" data-mp="81yyamcgo45k">{t.footer.explore}</h2>
            <ul className="mt-3" data-id="element-119" data-mp="34p6j01lngek">
              {links.map(l => <li key={l.href} data-id="element-120" data-mp="hsk3wtqjy8xz">
                  <a href={l.href} className={linkClass} data-id="element-121" data-mp="hrs75fl7y564">
                    {l.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div className="md:col-span-3" data-id="element-122" data-mp="qt05fxnqj607">
            <h2 className="text-[13px] font-medium text-cream/50" data-id="element-123" data-mp="qtroya425da4">{t.footer.contact}</h2>
            <ul className="mt-3" data-id="element-124" data-mp="mthk50s04swu">
              <li data-id="element-125" data-mp="mq3hdrffehov">
                <a href={`mailto:${business.email}`} className={linkClass} data-id="element-126" data-mp="tvczxt1gc7fo">
                  {business.email}
                </a>
              </li>
              <li data-id="element-127" data-mp="yupii1laiscg">
                <a href={business.phoneHref} className={linkClass} data-id="element-128" data-mp="ys3bc32baeur">
                  {business.phoneDisplay}
                </a>
              </li>
              <li className="flex min-h-[40px] items-center text-[15px] text-cream/75" data-id="element-129" data-mp="18k92xboniu9f">
                {t.footer.location}
              </li>
            </ul>
          </div>

          <div className="md:col-span-2" data-id="element-130" data-mp="1hkfe2qwvni5f">
            <h2 className="text-[13px] font-medium text-cream/50" data-id="element-131" data-mp="1hje0ofse2jkj">{t.footer.follow}</h2>
            <ul className="mt-3" data-id="element-132" data-mp="1mktp8htrz87o">
              <li data-id="element-133" data-mp="1mhpbotuf704c">
                <a href={business.instagram} target="_blank" rel="noopener noreferrer" className={`${linkClass} gap-3`} data-id="element-134" data-mp="1riv5kuztgtfg">
                  <InstagramGlyph data-id="element-135" data-mp="3t9yhdnlg0e1l" />
                  Instagram
                </a>
              </li>
              <li data-id="element-136" data-mp="2aevgo0iq629h">
                <a href={business.whatsapp} target="_blank" rel="noopener noreferrer" className={`${linkClass} gap-3`} data-id="element-137" data-mp="2afdm9nra1su2">
                  <MessageCircleIcon aria-hidden="true" className="h-[18px] w-[18px]" data-id="element-138" data-mp="21nv10yfh4mu4" />
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-white/10 pt-8 text-[13px] text-cream/55 md:flex-row md:items-center md:justify-between" data-id="element-139" data-mp="2tcy9kqee8jck">
          <p data-id="element-140" data-mp="2kdb4numggver">
            © {new Date().getFullYear()} Alma Yoga. {t.footer.rights}
          </p>
          <div className="flex gap-6" data-id="element-141" data-mp="2fe6zdf2njhtp">
            <a href="#" className="transition-colors duration-200 hover:text-white" data-id="element-142" data-mp="2fd5bga0jf0uk">
              {t.footer.privacy}
            </a>
            <a href="#" className="transition-colors duration-200 hover:text-white" data-id="element-143" data-mp="18zfoqjnq8imh">
              {t.footer.terms}
            </a>
          </div>
        </div>
      </div>
    </footer>;
}
function InstagramGlyph() {
  return <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="h-[18px] w-[18px]" data-id="element-144" data-mp="2wm7l7070uc28">
      <rect x="3" y="3" width="18" height="18" rx="5" data-id="element-145" data-mp="2nv7beeqgbqus" />
      <circle cx="12" cy="12" r="4" data-id="element-146" data-mp="2nrrxhf8iknuy" />
      <circle cx="17.5" cy="6.5" r="0.6" fill="currentColor" stroke="none" data-id="element-147" data-mp="3bjgsx4gmtsg4" />
    </svg>;
}